module.exports = __webpack_public_path__ + "img/y-156.b1c59a0d.png";